
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import { namespace } from "vuex-class";
import { InjectFunction } from "@common/src/utils/decorator";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

const partsCategory = namespace("parts-category");
const parts = namespace("parts");
const inventory = namespace("inventory");

@Component({ components: { TextTips } })
@InjectFunction("emptyToLine", "splitThousands", "permit", "permitApp", "appCode", "addCurrencyUnit")
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.select-spare-parts"),
  updateStatusFuncName: "",
  tableRefKey: "table"
})
export default class ComPartsSelectionDialog extends Vue {
  @Prop({ default: false, type: Boolean })
  visible: boolean;
  @Prop({ default: () => [], type: Array })
  shelfList: any;
  @Prop({ default: () => ({}), type: Object })
  queryParams: any;
  @Prop({ default: "", type: String })
  businessPage: any; // inventoryCheck - 库存盘点
  @Prop({ default: false, type: Boolean })
  showSelectAll: boolean;
  @inventory.Action getPartsInventoryList;
  @inventory.Action queryPartialStocktakingUncheckedInventory;
  @partsCategory.Action getCategoryList;
  @parts.Action getPartsBrandList;
  @parts.Action getPartsList;
  brandList: any = [];
  categoryList: any = [];
  inventoryFilterList: any = [
    {
      label: t("base.all"),
      value: "1"
    },
    {
      label: t("v216_6.inventory-of-spare-parts"),
      value: "0"
    }
  ];
  searchForm = {
    shelfCode: "",
    partsName: "",
    partsCategoryCode: "",
    brandCode: "",
    findInvEmpty: "1"
  };

  get searchList() {
    return [
      {
        label: t("v210.location"),
        type: "select",
        value: "",
        selectList: this.shelfList,
        prop: "shelfCode"
      },
      {
        label: t("parts.name"),
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("parts.category"),
        type: "cascader",
        prop: "partsCategoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      {
        label: t("setting.brand"),
        type: "select",
        selectList: this.brandList,
        value: "",
        prop: "brandCode"
      },
      {
        label: t("v213.Inventory-qty"),
        type: "select",
        selectList: this.inventoryFilterList,
        value: "1",
        resetValue: "1",
        prop: "findInvEmpty"
      }
    ];
  }
  created() {
    this.init();
  }
  init() {
    this.getCategoryList().then(data => {
      this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
    });
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }

  partsList: any = [];
  @Table.LoadDataMethod()
  loadListData() {
    const queryApi =
      this.businessPage === "inventoryCheck"
        ? this.queryPartialStocktakingUncheckedInventory
        : this.getPartsInventoryList;
    return queryApi({
      ...this.searchForm,
      ...this.queryParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.partsList = data.data?.list || [];
      return data;
    });
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleConfirmSelect() {
    this.$emit("confirm", this.mix_selectedRows);
  }
  handleSearch(data) {
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleCloseCancel() {
    this.$emit("update:visible", false);
  }
  @Watch("visible")
  visibleChange(val) {
    if (val) {
      this.mix_pageNum = 1;
      this.mix_pageSize = 10;
      this.mix_selectedRows = [];
      this.partsList = [];
      if (this.$refs["searchBar"]) {
        (this.$refs["searchBar"] as any).reset();
      } else {
        this.loadListData();
      }
    }
  }
  handleSelectAll() {
    this.$emit("selectAll", { ...this.searchForm, ...this.queryParams });
  }
}
